@use "../../styles/mixins/component-wrapper" as wrapper;

@include wrapper.layered-component {
  .list {
    padding-inline-start: 0; // reset browser default
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--semantic-spacing-list-m);
    font-family: var(--semantic-font-family-body);
    font-size: var(--semantic-font-size-body-m);
    font-style: normal;
    font-weight: var(--semantic-font-weight-body);
    line-height: var(--semantic-line-height-body-m);
    letter-spacing: var(--semantic-letter-spacing-body-m);
    color: var(--semantic-color-on-surface-primary-resting);

    &:has(.icon) {
      list-style-type: none;
    }

    .list--bullet {
      font-family: "Allianz Icons"; // stylelint-disable -- Declaration of custom font.

      &::before {
        vertical-align: middle;
      }
    }

    .list--item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: var(--list-m-item-gap);
    }

    .list--text {
      word-break: break-word;
    }
  }

  .theme--inverted {
    .list,
    .list .list--item .icon.c-icon--check,
    .list .list--item .icon.c-icon--product-cross {
      color: var(--semantic-color-on-surface-primary-inverse-resting);
    }
  }

  .theme--colorful,
  .list.list--colorful {
    .list--item {
      .icon {
        &.c-icon--check {
          color: var(--semantic-color-signal-attention-positive-resting);
        }

        &.c-icon--product-cross {
          color: var(--semantic-color-signal-attention-critical-resting);
        }
      }
    }
  }

  .theme--inverted.theme--colorful,
  .list.list--colorful {
    .list {
      .list--item {
        .icon {
          &.c-icon--check {
            color: var(--semantic-color-signal-attention-inverse-positive-resting);
          }

          &.c-icon--product-cross {
            color: var(--semantic-color-signal-attention-inverse-critical-resting);
          }
        }
      }
    }
  }
}
